import { render, staticRenderFns } from "./ChannelPill.vue?vue&type=template&id=6184ed70&scoped=true"
import script from "./ChannelPill.vue?vue&type=script&lang=js"
export * from "./ChannelPill.vue?vue&type=script&lang=js"
import style0 from "./ChannelPill.vue?vue&type=style&index=0&id=6184ed70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6184ed70",
  null
  
)

export default component.exports